import type { FamilyListItem } from "./familyLists";

export function isMyHouseTask(item: FamilyListItem, userUid?: string) {
  return Boolean(userUid) && item.kind === "house"
    && (!item.assigneeUid || item.assigneeUid === userUid);
}

export function isAvailableHouseTask(item: FamilyListItem, userUid?: string) {
  return !item.done && isMyHouseTask(item, userUid);
}
